// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__12_nF","large":"styles_large__1KQj9"};